$(document).ready(function() {
  // tab handler
  $('.tabs-wrapper').each(function(){
    var active, content, links = $(this).find('a');
    active = links.first().addClass('active');
    content = $(active.attr('href'));
    links.not(':first').each(function () {
      $($(this).attr('href')).hide();
    });
    $('.img-banner-wrapper').hide()
    $('.qa-wrapper').hide()
    $(this).find('a').click(function(e){
      // if (getCurrentFlavorQty(getSelectedFlavors()) == 4) {
      //   active = $('.tabs-wrapper').find('a.active')
      //   active.removeClass('active')
      //   content = $(active.attr('href'))
      //   content.hide()
      //   content = $($(this).attr('href'));

      //   if ($(this).attr('href').indexOf('#tab-2') > -1) {
      //     $('.img-banner-wrapper').show()
      //     $('.qa-wrapper').show()
      //     $('.how-wrapper').hide()
      //     $('.solace-ingredients-wrapper').hide()
      //   } else {
      //     $('.img-banner-wrapper').hide()
      //     $('.qa-wrapper').hide()
      //     $('.how-wrapper').show()
      //     $('.solace-ingredients-wrapper').show()
      //   }
      //   $(this).addClass('active');
      //   content.show();
      //   return false;
      // }
    });
  });
  // one time purchase is selected or not
  function isOneTime() {
    formData = $('#add-item-form').serializeArray()

    for (i=0; i<formData.length; i++) {
      if (formData[i].name == 'purchase_type') {
        if (formData[i].value == "onetime") {
          return true
        }
      }
    }

    return false
  }
  function addFlavor(flavorItem, cnt) {
    if (cnt <= 4) {
      $('#add-item-form').append(
        '<input type="hidden" data-index="' + 
        cnt + 
        '" name="properties[' + 
        flavorItem + 
        ']" value="' + 
        flavorItem+'"/>'
      )
    }
  }
  function removeFlavor(flavorItem, cnt) {
    if (cnt == 0) {
      $('input[type="checkbox"][name="properties['+flavorItem+']"]').parent().removeClass('active')
      $('input[type="checkbox"][name="properties['+flavorItem+']"]').prop('checked', false)
      $('.flavor-item[data-value="'+flavorItem+'"]').remove()
    } else {
      var element = $('input[type=hidden][name="properties[' + flavorItem +']"]')[0];
      element.parentNode.removeChild(element);
    }
  }
  $('.flavors-group').on('click', 'a.QuantitySelector__Button.downFlavorQty', function(e) {
    var splitKey = ['/4', '/4 Flavors'],
        currentQty = parseInt($(this).next().val().split(splitKey[0])[0]),
        numberOfFlavors = parseInt($('.numberOfFlavors').text().split(splitKey[1])[0])
    if (currentQty > 0) {
      $(this).next().val((currentQty - 1).toString() + splitKey[0])
      $('.numberOfFlavors').text((numberOfFlavors-1) + splitKey[1])
      removeFlavor($(this).attr('for'), currentQty - 1)
    }
    // e.preventDefault();
  });
  $('.flavors-group').on('click', 'a.QuantitySelector__Button.upFlavorQty', function(e) {
    var splitKey = ['/4', '/4 Flavors'],
        currentQty = parseInt($(this).prev().val().split(splitKey[0])[0]),
        numberOfFlavors = parseInt($('.numberOfFlavors').text().split(splitKey[1])[0])
    if (currentQty < 4 && numberOfFlavors < 4) {
      $(this).prev().val((currentQty + 1).toString() + splitKey[0])
      $('.numberOfFlavors').text((numberOfFlavors+1) + splitKey[1])
      addFlavor($(this).attr('for'), currentQty + 1)
    }
    // e.preventDefault();
  });
  // get selected quantities by flavor item array
  function getCurrentFlavorQty(flavorItemList) {
    var result = 0
    formData = $('#add-item-form').serializeArray()
    $.each(formData, function(i,e){
      $.each(flavorItemList, function(j,f){
        if (e.value == f) result++
      })
    })
    return result
  }
  // add flavor quantity content
  function addFlavorQuantity(flavorItem) {
    var quantityDivcont = '<div class="flavor-quantity-selector">' + 
      '<a href="javascript:void(0);" class="QuantitySelector__Button downFlavorQty" for="' + 
      flavorItem + 
      '">-</a>' +
      '<input type="text" readonly class="QuantitySelector__CurrentQuantity" value="' + 
      getCurrentFlavorQty([flavorItem]) + 
      '/4">' +
      '<a href="javascript:void(0);" class="QuantitySelector__Button upFlavorQty" for="' + 
      flavorItem + 
      '">+</a>' +
    '</div>';
    return quantityDivcont;
  }
  // update check out button text
  $('.rc_block__type').click(function(e){
    var className = $(this).attr('class')
    if (className.indexOf('rc_block__type__autodeliver') > -1)  {
      $('#goNextTab').html('Choose Frequency &#8594;')
    } else {
      $('#goNextTab').html('Add to cart &#8594;')
    }
  });
  // add to cart button handler in first tab
  $('#goNextTab').click(function(e) {
    if (isOneTime()) {
      $('.ProductForm__AddToCart').click()  
    } else {
      if (getCurrentFlavorQty(getSelectedFlavors()) == 4) {
        $('#tab-1').hide()
        $('a[href="#tab-1"]').removeClass('active')
        $('#tab-2').show()
        $('a[href="#tab-2"]').addClass('active')
        window.scrollTo(0,0)
        $('.img-banner-wrapper').show()
        $('.qa-wrapper').show()
        $('.how-wrapper').hide()
        $('.solace-ingredients-wrapper').hide()
      } else {
        // Display warning modal
        var flavoursLeft = 4 - getCurrentFlavorQty(getSelectedFlavors());
        var flavourText = (flavoursLeft == 1 ? "flavour" : "flavours");
        swal({
          icon: "warning",
          title: "Please choose " + flavoursLeft + " more " + flavourText
        });
      }
    }
  });
  // back button handler in second tab
  $('#backPreviousTab').click(function(e){
    $('#tab-2').hide()
    $('a[href="#tab-2"]').removeClass('active')
    $('#tab-1').show()
    $('a[href="#tab-1"]').addClass('active')
    window.scrollTo(0,0)
    $('.img-banner-wrapper').hide()
    $('.qa-wrapper').hide()
    $('.how-wrapper').show()
    $('.solace-ingredients-wrapper').show()
  });
  // add to cart button handler in second tab
  $('#slaveAddToCart').click(function(e) {
    console.log('Processing:', $('#add-item-form').serializeArray())
    $('.ProductForm__AddToCart').click()
  });
  // handle subscription period
  $('.package-wrapper').each(function(){
    var active, items = $(this).find('.package-item')
    active = items.first().addClass('active')
    $(this).find('.package-item').click(function(e){
      var freq = parseInt($(this).find('span').data('value'))
      var selectFreq = $('select[name="properties[shipping_interval_frequency]"]')
      active.removeClass('active')
      active = $(this)
      active.addClass('active')
      if (selectFreq.length > 0) {
        selectFreq.val((freq*7).toString())
      }
      return false
    });
  });
  // remove duplicated item from array
  function unique(list) {
    var result = []
    $.each(list, function(i,e){
      if ($.inArray(e, result) == -1) result.push(e)
    })
    return result
  }
  // get selected flavor items
  function getSelectedFlavors() {
    var formArray = $('#add-item-form').serializeArray()
    selectedFlavors = []
    if (formArray.length > 0) {
      for (i=0; i< formArray.length; i++) {
        if ( formArray[i].name.indexOf('properties') > -1 && 
          formArray[i].name.indexOf('subscription_id') < 0 && 
          formArray[i].name.indexOf('shipping_interval_unit_type') < 0 && 
          formArray[i].name.indexOf('shipping_interval_frequency') < 0 ) {
            selectedFlavors.push(formArray[i].value)
        }
      }
    }
    selectedFlavors = unique(selectedFlavors)
    return selectedFlavors
  }
  // fill 3rd column - flavor items group
  function buildFlavorsList(selectedFlavors) {
    $('.flavors-group').html('')
    if (selectedFlavors.length > 0) {
      for (i=0; i<selectedFlavors.length; i++) {
        $('.flavors-group').append(
          '<div class="flavor-item" data-value="' + 
          selectedFlavors[i] + 
          '">' + 
          selectedFlavors[i] + 
          ':' + 
          addFlavorQuantity(selectedFlavors[i]) + 
          '</div>'
        )
      }
    } else {
      $('.flavors-group').append('<div class="flavor-item">Please Select Flavor</div>')
    }
    $('.numberOfFlavors').text(getCurrentFlavorQty(selectedFlavors) + '/4 Flavors')
  }
  // handle checked flavor items
  $('.grid-child-wrapper').each(function() {
    var active, items = $(this).find('.grid-child-element')
    $('.grid-child-element').find('input').prop('checked', false)
    active = items.first()
    active.find('input').prop('checked', true)
    active.addClass('active')
    buildFlavorsList(getSelectedFlavors())

    $(this).find('.grid-child-element').click(function(e) {
      if ($(this).attr('class').indexOf('active') > -1) {
        var element = $(this).find('input'),
            flavorItem = element.val();
        $(this).removeClass('active');
        // element.prop('checked', false);

        for (var i=getCurrentFlavorQty([flavorItem])-1; i>-1; i--) {
          removeFlavor(flavorItem, i)
        }
      } else {
        if (getCurrentFlavorQty(getSelectedFlavors()) < 4) {
          $(this).addClass('active');
          $(this).find('input').prop('checked', true);
        }
      }

      buildFlavorsList(getSelectedFlavors())
      return false;
    });
  });
  // variant select handler
  $('.strength-list').each(function(){
    var active, items = $(this).find('.grid-child-element')
    active = items.first().addClass('active')
    var selected_variant = items.first().data('value')
    $(this).find('.grid-child-element').click(function(e) {
      selected_variant = $(this).data('value')
      $('button[data-value="'+selected_variant+'"]').trigger('click')
      active.removeClass('active')
      active = $(this)
      active.addClass('active')
      return false
    });
  });
  // Q&A handler
  $('.accordion').each(function() {
    $(this).click(function(e) {
      var className = $(this).attr('class')
      if (className.indexOf('active') > -1)  {
        $(this).removeClass('active')
      } else {
        $(this).addClass('active')
      }
      if ($(this).next().css('display') == 'none') {
        $(this).next().show()
      } else {
        $(this).next().hide()
      }
      return false;
    });
  });
});